import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ComponentFactory, ComponentFactoryResolver, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChartColor, ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { ToastrService } from 'ngx-toastr';
import { BeatblipUtils } from 'src/app/consts/beatblip-utils';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ExcelService } from 'src/app/_services/excel.service';
import { ProjectService } from 'src/app/_services/project.service';
import { ReportService } from 'src/app/_services/report.service';
import { TestService } from 'src/app/_services/test.service';

@Component({
  selector: 'app-tag-test-step-report',
  templateUrl: './tag-test-step-report.component.html',
  styleUrls: ['./tag-test-step-report.component.scss']
})
export class TagTestStepReportComponent implements OnInit {

  headerOptions = {
    showSetting: true,
    showSearch: false,
    heading: "Tag Step Report",
    data: undefined,
  };
  projectId: any;
  projectReportData: any;
  projectData: Object;
  projectName: any;
  reportId: string;
  testDataId: string;
  dataIterationIndex: any;
  path: string;
  title: string;
  status: string;
  reportForNavBar: string;
  iteration= 0;
  testSuiteReportData: Object;
  testCaseReportData: any;
  emailIdforReport={list:[]}
  haveEmailIDs: boolean = true;
 enableAuditInfo: boolean =false;
  enableScreenPath: boolean = false;
  public chartOptionSelect = ['pie','bar'];
  copyMessage: any;
  public barChartColors: ChartColor[] = [
    'rgb(92, 184, 92)',
    'rgb(217, 83, 79)',
    'rgb(236, 59, 15)',
    'rgb(240, 173, 78)',
     'rgb(91, 192, 222)', 
     'rgb(102, 205, 170)'
  ]
  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'bottom',
    }
  };
  charData: any=[];
  public barChartLabels: Label[];
  public barChartType: ChartType = 'pie';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataSets[]=[];
  public pieColor: ChartColor[]=[];
  chartList: Array<Object> = [];
  blinkArry: any[]=[];
  numarray: Array<Number>=[];
  testLabels: any[] = [];
  suiteIndex=0;
  totalSteps: any;
  passCount: number;
  failCount: number;
  blockedCount: number;
  incolusiveCount: number;
  notRunCount: number;
  skippedCount: number;
  componentFactory: ComponentFactory<any>;
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;
  timeZone: any;
  tagExecutionStats: any;
  next: boolean;
  previous: boolean;
  preLink: boolean;
  nextLink : boolean;
  testStepReport: any;

  constructor(
    private report: ReportService,
    private project: ProjectService,
    private testService:TestService,
    private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private route: ActivatedRoute,
  private router: Router,
  private toastrService:ToastrService,
  private confirmationDialogService:ConfirmationDialogService,
  private excelService:ExcelService,
  private utils: BeatblipUtils,
  private componentFactoryResolver: ComponentFactoryResolver,
  
  @Inject( DOCUMENT ) private document: Document,
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.projectId = params.get('pid');
      this.reportId = params.get('reportid');
      this.testDataId = params.get('testDataId');
      this.dataIterationIndex = params.get('dataIterationIndex');
      this.path = params.get('path');
    });
    this.project.getProjectById(this.projectId).subscribe((res) => {
      this.headerOptions.data = {
        projectId: this.projectId,
        projectName: res["projectName"],
      };
    });
    this.getTestSuiteTestReport(this.projectId,this.reportId,this.testDataId,this.path,this.dataIterationIndex);
    this.setTagTestStepReportData()
  }



  


  toggleWithGreeting(popover, greeting: string, language: string) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open({greeting, language});
    }
  }


  setTagTestStepReportData(){
    this.report.tagTestCaseReport(this.projectId,this.reportId).subscribe((data) => {
      this.tagExecutionStats = data['testExecutionStats']
      let index = this.tagExecutionStats.findIndex(x => x.testDataId === this.testDataId);
      //console.log('inxed',index,': length of object',this.tagExecutionStats.length-1);
      
      if(index===this.tagExecutionStats.length - 1){
        this.nextLink = false;
        this.preLink = true;
      }else if(index ===0){
        this.preLink = false;
        this.nextLink = true;
      }else{
        this.preLink = true;
        this.nextLink = true;
      }
    })
  }

  getNext(){
  //console.log(this.tagExecutionStats);
  let index = this.tagExecutionStats.findIndex(x => x.testDataId === this.testDataId);
  //console.log('index',index);
  
  for (var i = index; i < this.tagExecutionStats.length; i++) {
    var next = this.tagExecutionStats[i + 1];
    this.router.navigate(['tagTestStepReport/'+this.projectId+'/'+this.reportId+'/'+next.testDataId+'/'+next.dataIterationIndex+'/'+next.path]);
    
    setTimeout(() => {
      this.document.defaultView.location.reload();
      // this.getTestSuiteTestReport(this.projectId,this.reportId,next.testDataId,next.path,next.dataIterationIndex);
    }, 0);
    break;
  }

  }

  getPrevious(){
    //console.log(this.tagExecutionStats);
    let index = this.tagExecutionStats.findIndex(x => x.testDataId === this.testDataId);
    for (var i = index; i < this.tagExecutionStats.length; i++) {
        var previous = this.tagExecutionStats[i-1];
        //console.log('previous',previous);
        this.router.navigate(['tagTestStepReport/'+this.projectId+'/'+this.reportId+'/'+previous.testDataId+'/'+previous.dataIterationIndex+'/'+previous.path]);
        setTimeout(() => {
          this.document.defaultView.location.reload();
        }, 0);
        break;
        // this.document.defaultView.location.reload();
    }
  
    }
  
  onPageChange(newValue) {
    this.selectedPage = newValue;
    this.perpageitem = newValue;
  }
  copyToClipboard(item): void {
    //console.log(item)
    // let listener = (e: ClipboardEvent) => {
    //     e.clipboardData.setData('text/plain', (item));
    //     e.preventDefault();
    // };
  
    // document.addEventListener('copy', listener);
    // document.execCommand('copy');
    // document.removeEventListener('copy', listener);
    this.utils.copyToClipboard(item);
    this.toastrService.clear();
    this.toastrService.success('Copy To Clipboard');
  }
  
  selectChartType(chartType){
    this.barChartType = chartType;
  }
  // goBack() {
  //   this.location.back();
  // }
  
  getTestSuiteTestReport(projectid,reportId,testDataId,dataIterationIndex,path){
    this.testService.getTestCaseTestReport(projectid,reportId,testDataId,dataIterationIndex,path).subscribe(
      data=>{
        this.testCaseReportData = []
        this.barChartData = []
        this.testStepReport  = []
        this.testCaseReportData=data;
        this.testStepReport = this.testCaseReportData['testStepReport']
        //console.log('testCaseReportData ', this.testCaseReportData);
        //console.log('testCaseReportData ', this.testCaseReportData.aggrResultState);
        this.totalSteps = this.testCaseReportData.testStepReport.length;
       this.passCount = 0;
        this.failCount = 0;
        this.blockedCount=0;
        this.incolusiveCount=0;
        this.notRunCount = 0;
        this.skippedCount = 0;
        for(let i=0; i< this.totalSteps; i++){
        if(this.testCaseReportData.testStepReport[i].resultState.status=='PASS'){
          this.passCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='FAIL'){
          this.failCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='BLOCKED'){
          this.blockedCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='INCONCLUSIVE'){
          this.incolusiveCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='NOTRUN'){
          this.notRunCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='SKIPPED'){
          this.skippedCount++
        }
        }
           //console.log(this.passCount);
           
        
          let chartObj = new Object();
          chartObj['pass'] = this.passCount;
          chartObj['fail'] = this.failCount;
          chartObj['blocked'] = this.blockedCount;
          chartObj['inconclusive'] = this.incolusiveCount
          chartObj['notRun'] = this.notRunCount;
          chartObj['skipped'] = this.skippedCount;
          this.chartList.push(chartObj);
        this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
        for(let c of this.chartList){
          this.blinkArry.push(Object.values(c));
        }
        this.numarray = JSON.parse(JSON.stringify(this.blinkArry[0]));
        const toNumbers = arr => arr.map(Number);
         var n = toNumbers(this.numarray);
        this.barChartData = [{ data:  n,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors}];
      }
    )
  }
  
  
  
  addEmailIdForReport(addEmailForm){
    this.emailIdforReport.list.push(addEmailForm.value.userEmail)
    this.haveEmailIDs=false;
  //console.log(this.emailIdforReport);
  addEmailForm.reset();
  }
  
 

  
  onChecked(isChecked: boolean) {
    if(isChecked) {
      this.enableAuditInfo = true;
    } else{
      this.enableAuditInfo = false;
    }
  }
  
  onCheckedPath(isChecked: boolean) {
    if(isChecked) {
      this.enableScreenPath = true;
    } else{
      this.enableScreenPath = false;
    }
  }


  tagReport(){
    this.router.navigate(['/report/projectTagReport/' + this.projectId]);
  }
  tagTestCaseReport(){
    this.router.navigate(['/report/tagTestCaseReport/' + this.projectId+'/'+this.reportId]);
    }
  }


